<template>
  <v-card width="auto" variant="text">
    <header-view></header-view>

    <div class="d-flex justify-center">
      <v-sheet width="350" class="bg-color">
        <v-img
          @contextmenu.prevent
          src="@/assets/under-maintenance.png"
          lazy-src="@/assets/under-maintenance.png"
          width="400"
        ></v-img>
        <p class="text-h6 font-weight-bold text-center">
          {{ $t("error.unknown") }}
        </p>
      </v-sheet>
    </div>

    <v-divider class="border-opacity-50 mt-4" thickness="2"></v-divider>

    <v-card-item>
      <card-footer></card-footer>
    </v-card-item>
  </v-card>
</template>

<script>
import CardFooter from "@/components/footer/CardFooter.vue";
import HeaderView from "@/components/header/Header.vue";

export default {
  name: "NoProduct",

  components: {
    CardFooter,
    HeaderView,
  },
};
</script>
